export const ADDRESS_MARKS_STORAGE_KEY = "address_marks";
export const ADDRESS_MARKS_UPDATED_EVENT = "address-marks-updated";

export type StoredMarkGroups = Array<Record<string, any>>;

export function readAddressMarksFromStorage(): StoredMarkGroups {
	if (typeof window === "undefined") return [];

	try {
		const raw = window.localStorage.getItem(ADDRESS_MARKS_STORAGE_KEY);
		if (!raw) return [];

		const parsed = JSON.parse(raw);
		return Array.isArray(parsed) ? parsed : [];
	} catch {
		return [];
	}
}

export function writeAddressMarksToStorage(value: unknown) {
	if (typeof window === "undefined") return;

	window.localStorage.setItem(
		ADDRESS_MARKS_STORAGE_KEY,
		JSON.stringify(value),
	);
	window.dispatchEvent(new CustomEvent(ADDRESS_MARKS_UPDATED_EVENT));
}

export function subscribeAddressMarksUpdates(callback: () => void) {
	if (typeof window === "undefined") return () => {};

	const handleStorage = (event: StorageEvent) => {
		if (event.key === null || event.key === ADDRESS_MARKS_STORAGE_KEY) {
			callback();
		}
	};

	const handleCustomEvent = () => {
		callback();
	};

	window.addEventListener("storage", handleStorage);
	window.addEventListener(ADDRESS_MARKS_UPDATED_EVENT, handleCustomEvent);

	return () => {
		window.removeEventListener("storage", handleStorage);
		window.removeEventListener(ADDRESS_MARKS_UPDATED_EVENT, handleCustomEvent);
	};
}
